// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e55c3775","460":"bd9885dc","511":"10d80934"}[chunkId] + ".chunk.js";
};